import React from 'react';

const displayFont = { fontFamily: "'Fraunces', serif" };

const AboutSection = () => {
  return (
    <section id="about" className="scroll-mt-[88px] py-20 px-6 md:px-16 bg-[#F4F8FC]">
      <div className="max-w-4xl mx-auto text-center">
        <h2 style={displayFont} className="text-3xl md:text-4xl text-[#101826] mb-5">
          About Eduvantra
        </h2>
        <p className="text-[#5A6478] text-lg leading-relaxed max-w-2xl mx-auto">
          Eduvantra is built by{' '}
          <a
            href="https://www.isnartech.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#2E63B8] font-semibold hover:text-[#163863] transition-colors"
          >
            Isnartech Pvt. Ltd.
          </a>{' '}
          — a team focused on giving schools in India one dependable system
          instead of a patchwork of spreadsheets, apps and paperwork. From
          admissions to attendance, fees to report cards, Eduvantra keeps
          school owners, faculty, students and parents connected on a single
          platform, built to scale from one classroom to a multi-branch group.
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
